import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { MotSeasonProposal } from '@app/activo2/manage-vacations/manage-vacations.model';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

@Component({
  selector: 'app-proposal-card',
  templateUrl: './proposal-card.component.html',
  styleUrls: ['./proposal-card.component.scss']
})
export class ProposalCardComponent implements OnChanges {
  @Input() proposal!: MotSeasonProposal;
  @Input() canEdit!: boolean;
  @Input() isMomoUser!: boolean;
  @Input() showEmptyProposals = true;

  @Output() editClicked: EventEmitter<MotSeasonProposal> = new EventEmitter<MotSeasonProposal>();
  @Output() addProposalsClicked: EventEmitter<MotSeasonProposal> = new EventEmitter<MotSeasonProposal>();

  hasProposalsFullfilled!: boolean;
  maxProposals: number[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.proposal) {
      this.hasProposalsFullfilled = this.proposal.hasAnyProposalFullfilled();
    }

    this.maxProposals = this.isMomoUser ? [1, 2] : [1, 2, 3, 4];
  }

  onEditClicked() {
    if (this.canEdit && this.hasProposalsFullfilled) {
      this.editClicked.emit(this.proposal);
    }
  }

  onAddProposalsClicked() {
    this.addProposalsClicked.emit(this.proposal);
  }

  trackByItems(item: MSafeAny) {
    return item;
  }
}
